import { atom } from "recoil";

export const notificationState = atom({
  key: "notificationState",
  default: {
    title: null,
    message: null,
    type: "error", // success, warning, error, info, warning,
    duration: 5000,
    show: false,
  },
});
